"use strict";
/*
   Implemented as per the logic described here https://swyftx.atlassian.net/wiki/spaces/TS/pages/2009858087/Significant+digits+logic
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceScale = exports.DEFAULT_SIGNIFICANT_DIGITS = exports.MIN_PRICE_SCALE = exports.MAX_PRICE_SCALE = void 0;
const big_1 = __importDefault(require("@swyftx/big"));
exports.MAX_PRICE_SCALE = 16;
exports.MIN_PRICE_SCALE = 2;
exports.DEFAULT_SIGNIFICANT_DIGITS = 4;
const getPriceScale = (amount, significantDigits = exports.DEFAULT_SIGNIFICANT_DIGITS) => {
    const parsedAmount = (0, big_1.default)(amount).abs();
    const calculatedPriceScale = significantDigits - 1 - Math.floor(Math.log10(parsedAmount.toNumber()));
    if (parsedAmount.lte(1) && calculatedPriceScale !== Infinity) {
        return calculatedPriceScale;
    }
    else if (parsedAmount.lte(100)) {
        return exports.MIN_PRICE_SCALE + 1;
    }
    else {
        return exports.MIN_PRICE_SCALE;
    }
};
exports.getPriceScale = getPriceScale;
//# sourceMappingURL=getPriceScale.js.map